import { render, staticRenderFns } from "./DanhSachDonVi.vue?vue&type=template&id=3ee149ea&"
import script from "./DanhSachDonVi.vue?vue&type=script&lang=js&"
export * from "./DanhSachDonVi.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachDonVi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports